module.exports = __webpack_public_path__ + "img/Food.74301214.png";